
import { LinkedInApi } from '@/api';
import PlatformDisconnectRow from '@/components/social/PlatformDisconnectRow.vue';
import { GENERIC_ERROR_DESCRIPTION } from '@/constants';
import { BotMixin } from '@/mixins/BotMixin';
import isEqual from 'fast-deep-equal/es6';
import { LinkedInPlatformData, SupportedPlatform } from 'ignite360-core';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';

type LinkedInSettings = Pick<LinkedInPlatformData, 'enablePosting' | '_id' | 'type'>;

@Component({
  name: 'linked-in-settings-card',
  components: { PlatformDisconnectRow },
})
export default class LinkedInSettingsCard extends mixins(BotMixin) {
  @Prop({ required: false, type: Boolean, default: false })
  readonly showDisconnect!: boolean;

  linkedInSettings = this.resetValue();

  isSubmitting = false;
  isDisconnecting = false;

  get settingsHaveChanged(): boolean {
    return !isEqual(this.linkedInSettings, this.resetValue());
  }

  async onSubmit() {
    this.isSubmitting = true;
    try {
      await this.$updateBotPlatform({
        id: this.bot.id,
        platform: SupportedPlatform.LinkedIn,
        data: this.linkedInSettings,
      });
      this.$notify.success('Successfully updated LinkedIn-settings');
    } catch (e) {
      this.$notify.error({
        title: 'Updating LinkedIn-settings failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isSubmitting = false;
    }
  }

  async onDisconnect() {
    this.isDisconnecting = true;
    try {
      await LinkedInApi.disconnectBotFromLinkedInPage(this.bot.id);
      this.$emit('disconnect');
      this.$notify.success('Successfully disconnected from LinkedIn');
    } catch (e) {
      this.$notify.error({
        title: 'Disconnecting from LinkedIn failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isDisconnecting = false;
    }
  }

  @Watch('bot', { immediate: true, deep: true })
  private reset() {
    this.linkedInSettings = this.resetValue();
  }

  private resetValue(): LinkedInSettings {
    return {
      enablePosting: this.bot.platformData.linkedIn.enablePosting,
      _id: this.bot.platformData.linkedIn._id,
      type: this.bot.platformData.linkedIn.type,
    };
  }
}
